<template>
  <div class="rt">
    <div class="rt-bottom" ref="Rtbottom" :style="{ width: '100%', height: '100%' }"></div>
  </div>
</template>

<script>
import * as methods from './method.js'

export default {
  name: "template.scope11",
  props: {
    vdata: {
      type: [Array, String],
      default: () => []
    },
    jsondata: {
      type: [Array, String],
      default: () => []
    },
    valuemap: {
      type: [Array, String],
      default: () => []
    },
    scopedata: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      isList: true,
      defaultdata: [
        { value1: '数据一', value2: '系列一', value3: '4', value4: '系列二', value5: '3', value6: '系列三', value7: '15', value8: '系列四', value9: '15', value10: '元', value11: '%' },
        { value1: '数据二', value2: '系列一', value3: '6', value4: '系列二', value5: '5', value6: '系列三', value7: '80', value8: '系列四', value9: '15', },
        { value1: '数据三', value2: '系列一', value3: '3', value4: '系列二', value5: '2', value6: '系列三', value7: '25', value8: '系列四', value9: '15', },
        { value1: '数据四', value2: '系列一', value3: '4', value4: '系列二', value5: '3', value6: '系列三', value7: '20', value8: '系列四', value9: '15', },
        { value1: '数据五', value2: '系列一', value3: '3', value4: '系列二', value5: '2', value6: '系列三', value7: '18', value8: '系列四', value9: '15', },
        { value1: '数据六', value2: '系列一', value3: '5', value4: '系列二', value5: '4', value6: '系列三', value7: '25', value8: '系列四', value9: '15', },
        { value1: '数据七', value2: '系列一', value3: '4', value4: '系列二', value5: '3', value6: '系列三', value7: '33', value8: '系列四', value9: '15', },
      ],
      valueMap: [
        { name: "图表名称", key: "value1" },
        { name: '图例1', key: 'value2' },
        { name: '柱状图1数值', key: 'value3' },
        { name: '图例2', key: 'value4' },
        { name: '柱状图2数值', key: 'value5' },
        { name: '图例3', key: 'value6' },
        { name: '折线图数值', key: 'value7' },
        { name: '图例4', key: 'value8' },
        { name: '折线图2数值', key: 'value9' },
        { name: '单位（左）', key: 'value10' },
        { name: '单位（右）', key: 'value11' },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      config: {
      },
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    valuemap(n) {
      if (n && n.length) {
        this.valueMap = n
      }
    },
    vdata(n) {
      if (n && n.length) {
        this.defaultdata = n
        this.TdrawLine()
      }
    },
    jsondata(n) {
      this.exceldata = n
    },
  },
  methods: {
    ...methods,
    TdrawLine() {
      const _this = this
      var echarts = require("echarts");
      var TmyChart = echarts.init(this.$refs.Rtbottom);
      let data1 = [];
      let data2 = [];
      let data3 = [];
      let data4 = [];
      let legend = [];
      let unit1 = this.defaultdata[0].value10 || ''
      let unit2 = this.defaultdata[0].value11 || ''
      let xdata = this.defaultdata.map(item => item.value1)
      this.defaultdata.forEach((item, i) => {
        if (item.value2 && item.value3) {
          const vdata1 = { name: item.value2, value: item.value3 };
          data1.push(vdata1);
        }
        if (item.value4 && item.value5) {
          const vdata2 = { name: item.value4, value: item.value5 };
          data2.push(vdata2);
        }
        if (item.value6 && item.value7) {
          const vdata3 = { name: item.value6, value: item.value7 };
          data3.push(vdata3);
        }
        if (item.value8 && item.value9) {
          const vdata4 = { name: item.value8, value: item.value9 };
          data4.push(vdata4);
        }
        if (i == 0) {
          if (item.value2) {
            legend.push({
              top: "2%",
              left: "25%",
              itemHeight: 12, //图例的高度  文字左边那个
              itemWidth: 10,
              textStyle: { color: "#2C81DB" },
              data: [{ name: item.value2, icon: "rect" }],
            });
          }
          if (item.value4) {
            legend.push({
              top: "2%",
              left: "40%",
              itemHeight: 12, //图例的高度  文字左边那个
              itemWidth: 10,
              textStyle: { color: "#57E8CB" },
              data: [{ name: item.value4, icon: "rect" }],
            });
          }
          if (item.value6) {
            legend.push({
              top: "2%",
              left: "55%",
              itemHeight: 4, //图例的高度  文字左边那个
              itemWidth: 10,
              textStyle: { color: "#FFAD1D" },
              data: [{ name: item.value6, icon: "rect" }],
            });
          }
          if (item.value8) {
            legend.push({
              top: "2%",
              left: "70%",
              itemHeight: 4, //图例的高度  文字左边那个
              itemWidth: 10,
              textStyle: { color: "#3EF726" },
              data: [{ name: item.value8, icon: "rect" }],
            });
          }
        }
      });
      const colormap = ['#2C81DB', '#57E8CB', '#FFAD1D', '#3EF726']
      let series = []
      let mydata = [data1, data2, data3, data4]
      mydata.forEach((item, i) => {
        console.log('___mydata', item[0].name)
        let serie = {
          name: item[0].name,
          type: i > 1 ? "line" : "bar",
          yAxisIndex: i > 1 ? 1 : 0,
          smooth: true,
          data: item,
          barGap: '25%', //柱子之间间距
          barCategoryGap: '68%',
          lineStyle: {
            color: colormap[i]
          },
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: colormap[i] // 0% 处的颜色
              }, {
                offset: 1,
                color: "#0b1f42"// 100% 处的颜色
              }], false)
            }
          },
        }
        series.push(serie)
      })
      var Toption = {
        title: [
          {
            subtext: unit1 || '',
            subtextStyle: {
              color: "#B0B5BB"
            },
            top: "4",
            left: "8"
          },
          {
            subtext: unit2 || '',
            subtextStyle: {
              color: "#B0B5BB"
            },
            top: "4",
            right: "6"
          }
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            crossStyle: {
              color: "#999"
            }
          }
        },
        grid: {
          left: "50px",
          right: "40px",
          bottom: "50px",
          top: "50px"
          // containLabel: true
        },
        legend: legend,
        xAxis: [
          {
            type: "category",
            splitLine: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              interval: 0,
              // padding: [0, 0, 0, 40],
              margin: 12,
              textStyle: {
                color: "#bdc2cb" // 这里将 x 轴文本颜色设为灰白色
              }
            },
            axisPointer: {
              type: "shadow"
            },
            data: xdata
          }
        ],
        yAxis: [
          {
            type: "value",
            // name: "彩色",
            min: 0,
            // max: 250,
            // interval: 50,
            axisLabel: {
              textStyle: {
                color: "#bdc2cb" // 这里将 x 轴文本颜色设为灰白色
              },
              formatter: "{value} "
            },
            splitLine: {
              show: false
            }
          },
          {
            type: "value",
            // name: "同比",
            // min: 0,
            // max: 25,
            containLabel: true,
            // interval: 5,
            axisLabel: {
              textStyle: {
                color: "#bdc2cb" // 这里将 x 轴文本颜色设为灰白色
              },
              formatter: "{value} "
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "rgba(231,241,251,.2)"
              }
            }
          }
        ],
        series: [...series]
      };
      Toption && TmyChart.setOption(Toption);
      setInterval(function () {
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000);
    }
  },
  mounted() {
    if (this.valuemap && this.valuemap.length) {
      this.valueMap = this.valuemap
    }
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata
    }
    this.setData()
    this.$nextTick(() => {
      this.TdrawLine(); //需要刷新的数据
    });
  },
};
</script>

<style scoped lang="scss">
.rt {
  width: 100%;
  height: 240px;
  display: flex;
  padding: 10px 0;
  position: relative;
}

.rt-bottom {
  //减掉96px的高
  // padding: 10px 0;
  // margin-top: -10px;
  z-index: 5;
}
</style>